import { render, staticRenderFns } from "./UbicacionesCreate.vue?vue&type=template&id=5508f469&"
import script from "./UbicacionesCreate.vue?vue&type=script&lang=js&"
export * from "./UbicacionesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports